import { Component, OnInit } from '@angular/core';
import { ApiService } from '../../service/api_service';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { DailyExpenseModel } from '../../model'
import { HttpClient } from '@angular/common/http';
import { Router } from "@angular/router"
import * as $ from 'jquery';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-dailyexpense',
    template: require('./dailyexpense.component.html'),
    viewProviders: [ApiService]
})

export class DailyExpenseReportComponent implements OnInit {
    DailyExpenseData: DailyExpenseModel = new DailyExpenseModel();
    DailyExpenseDetails: any = [];
    busy: Subscription;
    private columnDefs;
    private rowHeight;
    api: any;
    empName: any = [];
    ManagerList: any;
    firstDate: string;
    lastDate: string;
    columnApi: any;
    defaultColDefine;
    private gridColumnApi;
    token:any;

    DailyExpense_Form = new FormGroup({
        fromDate: new FormControl('', [Validators.required]),
        toDate: new FormControl('', [Validators.required]),
        employeeCode: new FormControl('', [Validators.required]),
        ManagerID: new FormControl('', [Validators.required]),
        status: new FormControl('', [Validators.required]),
    });

    static parameters = [ApiService, Router, HttpClient]
    constructor(private apiService: ApiService, private router: Router, private http: HttpClient) {
        this.apiService = apiService;
        this.columnDefs = [
            { headerName: 'Sr. No', valueGetter: "node.rowIndex + 1", width: 80 },
            { headerName: 'Date', field: "Date" },
            { headerName: 'Employee Code', field: "Client_Code" },
            { headerName: 'Employee Name', field: "Client_Name" },
            { headerName: 'DOJ', field: "DOJ" },
            { headerName: 'Designation', field: "Designation" },
            { headerName: 'Reporting Manager', field: "Manager" },
            { headerName: 'HQ Name', field: "HQName" },
            { headerName: 'DA Local', field: "DaLocal" },
            { headerName: 'DA Local+', field: "DaLocalPlus" },
            { headerName: 'DA EX', field: "DaEx" },
            { headerName: 'DA EX (IN KMS)', field: "DaExKM" },
            { headerName: 'DA OS', field: "DaOs" },
            { headerName: 'Total Claim', field: "Total Claim" },
            { headerName: 'Approved Claim', field: "Approved Claim" },
            { headerName: 'Approved By', field: "Approved By" },
            { headerName: 'Status', field: "Status"},
            { headerName: 'Last Working Date', field: "Last Working Date" }
        ];
        this.rowHeight = 50;
        this.defaultColDefine = { resizable: true };

    }


    ngOnInit() {
        this.token = JSON.parse(sessionStorage.getItem("currentUser"));
        $('#filter-option').trigger('click');
        var date = new Date();
        var year = date.getFullYear();
        var month = (date.getMonth() + 1).toString().padStart(2, "0");
        this.firstDate = year + '-' + month + '-' + date.getDate().toString().padStart(2, "0");
        this.lastDate = year + '-' + month + '-' + date.getDate().toString().padStart(2, "0");
        console.log('firstDate ', this.firstDate, this.lastDate);
        this.DailyExpense_Form.controls['fromDate'].setValue(
            this.firstDate
        );
        this.DailyExpense_Form.controls['toDate'].setValue(
            this.lastDate
        );
        this.getEmployee();
        this.getManagerDetails();
        this.DailyExpenseData.employeeCode = "0";
        this.DailyExpenseData.ManagerID = 0;
        this.DailyExpenseData.status = -1;
    
    }
    getEmployee() {
        var data = {
            Id: this.token.id
        };
    this.apiService.getEmpDetails(data).subscribe((res: any) => {
            this.empName = res.data;
        })
    }

    getManagerDetails() {
        var data = {
            Id: this.token.id
        };
        this.http.post('/api/Report/getManagerListForLogUnLog',data)
            .subscribe(res => {
                this.ManagerList = res;
            });
    }
  
    onGridReady = (params) => {
        this.api = params.api;
        this.gridColumnApi = params.columnApi;
        this.api.hideOverlay();
    }

    onBtnExport() {
        this.api.exportDataAsExcel({ fileName: 'Monthly_Expense_Report' });
    }

    onFilterTextBoxChanged() {
        this.api.setQuickFilter(document.querySelector<HTMLInputElement>('#filter-text-box')!.value);
        this.api.refreshCells();
    }

    getDailyExpenseData() {
        this.DailyExpenseData.fromDate = this.DailyExpense_Form.value.fromDate;
        this.DailyExpenseData.toDate = this.DailyExpense_Form.value.toDate;
        let token = JSON.parse(sessionStorage.getItem("currentUser"));
        this.DailyExpenseData.empId = token.id;
        console.log(this.DailyExpenseData);
        this.busy = this.apiService.getDailyExpenseData(this.DailyExpenseData).subscribe((res: any) => {
            console.log("response", res)
            this.DailyExpenseDetails = res.data;
        })


    }

  
}
